<template>
  <div class="mb-5">
    <div class="flex items-center justify-between gap-3 flex-wrap">
      <div class="inline-flex flex-wrap items-center bg-[#E7E7E7] rounded-md p-1 overflow-x-auto gap-1">
        <button
          v-for="tab in tabs"
          :key="tab.value"
          type="button"
          class="px-4 py-2 text-sm rounded transition-colors whitespace-nowrap"
          :class="tab.value === activeTab
            ? 'bg-white text-primary-1 shadow-sm'
            : 'text-gray-700 hover:bg-white'"
          @click="$emit('update:activeTab', tab.value)"
        >
          {{ tab.label }}
        </button>
      </div>

      <div class="flex items-center gap-2 flex-wrap">
        <SegmentToggle
          :model-value="scope"
          :options="scopeOptions"
          @update:model-value="$emit('update:scope', $event)"
          v-if="activeTab === 'overview'"
        />

        <button
          type="button"
          class="inline-flex items-center gap-2 text-sm text-gray-600 bg-white border-1 rounded-md px-3 py-2 hover:bg-gray-50"
          @click="showAreaDrawer = true"
        >
          <div class="w-4 h-4 p-0.5 bg-primary-1 flex justify-center items-center rounded-sm">
            <BarChartIcon class="h-full w-full text-white" />
          </div>
          <span class="text-gray-500">ข้อมูล:</span>
          <span class="font-medium text-primary-1">{{ area }}</span>
        </button>

        <div class="dropdown">
          <button class="dropdown-toggle transition duration-200 shadow-sm sm:inline-flex py-2 font-medium cursor-pointer px-2 !box text-slate-500 w-9 h-9 flex items-center justify-center rounded-md text-primary-1 hover:bg-primary-1/40 bg-primary-1/20" aria-expanded="false" :disabled="exportingPdf">
            <DownloadIcon class="w-4 h-4" />
          </button>
          <div class="dropdown-menu w-48">
            <div class="dropdown-menu__content box dark:bg-dark-1 p-2">
              <button type="button" disabled class="flex items-center rounded-md w-full p-2 text-left text-gray-400 cursor-not-allowed" title="เร็วๆ นี้">
                ดาวน์โหลด .docx
              </button>
              <button type="button" disabled class="flex items-center rounded-md w-full p-2 text-left text-gray-400 cursor-not-allowed" title="เร็วๆ นี้">
                ดาวน์โหลด .xlsx
              </button>
              <button
                type="button"
                data-dismiss="dropdown"
                class="flex items-center rounded-md w-full p-2 text-left hover:bg-gray-200 disabled:text-gray-400 disabled:cursor-not-allowed"
                :disabled="exportingPdf"
                @click="$emit('download-pdf')"
              >
                {{ exportingPdf ? "กำลังสร้างไฟล์ PDF..." : "ดาวน์โหลด .pdf" }}
              </button>
            </div>
          </div>
        </div>

        <button type="button"
          class="inline-flex items-center gap-1.5 text-sm rounded-md bg-primary-1/20 px-3 py-1.5 hover:bg-primary-1/40 text-primary-1"
          @click="showGeneralFilterDrawer = true">
            <span
              v-if="activeFilterCount > 0"
              class="min-w-[14px] h-3.5 rounded-full bg-theme-5 text-white text-[9px] flex items-center justify-center font-medium leading-none px-0.5"
            >{{ activeFilterCount }}</span>
            <SlidersIcon class="w-4 h-4" v-else />
          ตัวกรอง
        </button>

        <!-- <button type="button"
          class="inline-flex items-center gap-1.5 text-sm rounded-md bg-primary-1/20 text-primary-1 px-3 py-1.5 hover:bg-primary-1/40"
          @click="showAddDataDrawer = true" disabled>
          <LayersIcon class="w-4 h-4" />
          แสดงผลเพิ่มเติม
        </button> -->
      </div>
    </div>
    <AreaFilterDrawer v-model="showAreaDrawer" @apply="onApplyArea" />
    <AddDataDrawer v-model="showAddDataDrawer" @add="$emit('add-data', $event)" />
    <GeneralFilterDrawer v-model="showGeneralFilterDrawer" :active-tab="activeTab" @apply="$emit('apply-filter', $event)" />
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import { useStore } from "vuex";
import SegmentToggle from "./SegmentToggle.vue";
import AreaFilterDrawer from "./AreaFilterDrawer.vue";
import AddDataDrawer from "./AddDataDrawer.vue";
import GeneralFilterDrawer from "./GeneralFilterDrawer.vue";

defineProps({
  tabs: { type: Array, default: () => [] },
  activeTab: { type: String, default: "" },
  scope: { type: String, default: "ครัวเรือน" },
  scopeOptions: { type: Array, default: () => [] },
  area: { type: String, default: "รายจังหวัด" },
  exportingPdf: { type: Boolean, default: false },
});
const emit = defineEmits(["update:activeTab", "update:scope", "update:area", "apply-area", "add-data", "apply-filter", "download-pdf"]);

const store = useStore();
const activeFilterCount = computed(() => {
  const gf = store.getters["dashboardOverviewFilter/generalFilter"];
  return (gf?.ageGroups?.length || 0) + (gf?.problemConditions?.length || 0);
});

const showAreaDrawer = ref(false);
const showAddDataDrawer = ref(false);
const showGeneralFilterDrawer = ref(false);
const onApplyArea = (selection) => {
  emit("update:area", selection.label);
  emit("apply-area", selection);
};
</script>
